import { NativeDateTimeAdapter } from '@danielmoncada/angular-datetime-picker';
import { Injectable } from '@angular/core';
import { DateFormatService } from './dateFormat.service';
import { DateFnsDateFormat, DateFnsTimeFormat } from '../enums/timePreference.enum';
import { getEnumList } from '../_helpers/enum-helper';
import { Platform } from '@angular/cdk/platform';
import { format } from 'date-fns';

@Injectable()
export class CustomOwlDateAdapter extends NativeDateTimeAdapter {
  constructor(private dateFormatService: DateFormatService, platform: Platform) {
    super('en', platform);
  }

  override format(date: Date, displayFormat: string): string {
    const { userDateFormat, userTimeFormat, userDateWithTimeFormat } = this.dateFormatService;
    const isTime = getEnumList(DateFnsTimeFormat).find(t => t.toLowerCase() === displayFormat.toLowerCase());
    const isDate = getEnumList(DateFnsDateFormat).find(d => d.toLowerCase() === displayFormat.toLowerCase());
    const fmt = isTime ? userTimeFormat : isDate ? userDateFormat : userDateWithTimeFormat;
    return format(date, fmt);
  }
}
